
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/book-stores-pos-billing-software",
      function () {
        return require("private-next-pages/outlet/book-stores-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/book-stores-pos-billing-software"])
      });
    }
  